import { Reveal, Chapter } from "./Reveal";

const CATS = [
  "Hair & beauty",
  "Nail techs",
  "Spas",
  "Barbers",
  "Wellness",
  "Small food businesses",
  "Other service businesses",
];

const WhoItsFor = () => (
  <section className="bg-guinep-deep py-12 text-white sm:py-14">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Chapter num="02" label="Who it's for" light />
      <div className="mt-6 max-w-2xl">
        <Reveal delay={0.05}>
          <h2 className="font-serif text-3xl font-medium leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl">
            Built for businesses that run through social.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p
            className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1.5 font-serif text-lg italic text-guinep-soft/90 sm:text-xl"
            data-testid="audience-categories"
          >
            {CATS.map((c, i) => (
              <span key={c} className="flex items-center gap-3">
                {i > 0 && <span className="text-white/30">·</span>}
                {c}
              </span>
            ))}
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/65 sm:text-base">
            If customers discover you on social and then message you for the details, Guinep Seed
            gives them those details first.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default WhoItsFor;
